import { GalleryItem } from 'components/Gallery'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

type ImageGalleryItemProps = {
  src: string
  alt: string
}

const AttachmentThumbnail = styled.img`
  width: 58px;
  height: 72px;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
`

export const ImageGalleryItem = ({ src, alt }: ImageGalleryItemProps) => {
  const [dimensions, setDimensions] = useState<{
    width: number
    height: number
  } | null>(null)

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const img = new Image()
    img.onload = () => {
      setDimensions({ width: img.naturalWidth, height: img.naturalHeight })
    }
    img.src = src
  }, [src])

  return (
    <GalleryItem
      src={src}
      alt={alt}
      width={dimensions?.width || 768}
      height={dimensions?.height || 1024}
    >
      {({ ref, open }: any) => (
        <AttachmentThumbnail
          ref={ref}
          src={src}
          alt={alt}
          onClick={(e) => {
            e.stopPropagation()
            open(e)
          }}
        />
      )}
    </GalleryItem>
  )
}
